// Styles
import './_main-article.scss';